export default "__VITE_ASSET__BmfUTF6g__"